import { useEffect, useState } from 'react';

/** Hora atual, atualizada na virada de cada minuto (ou no intervalo pedido). */
export function useNow(intervalMs = 60_000): Date {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    let interval: ReturnType<typeof setInterval> | undefined;
    // Alinha o primeiro tick à virada do minuto, para o relógio não ficar "atrasado".
    const first = setTimeout(
      () => {
        setNow(new Date());
        interval = setInterval(() => setNow(new Date()), intervalMs);
      },
      intervalMs - (Date.now() % intervalMs),
    );
    return () => {
      clearTimeout(first);
      if (interval) clearInterval(interval);
    };
  }, [intervalMs]);
  return now;
}

export const minutesOfDay = (d: Date) => d.getHours() * 60 + d.getMinutes();

export const fmtTime = (d: Date) => d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });

export function fmtDuration(totalMinutes: number): string {
  const h = Math.floor(totalMinutes / 60);
  const m = totalMinutes % 60;
  if (h === 0) return `${m} min`;
  return m === 0 ? `${h} h` : `${h} h ${m} min`;
}
